// FILENAME: frontend/src/pages/DealerPage.jsx
import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Dealer360View from '../components/Dealer360View';
import { Box } from '@mui/material';

const DealerPage = () => {
    const navigate = useNavigate();
    const { bac } = useParams();
    const location = useLocation();
    const searchMatch = location.state?.searchMatch || null;

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/', { replace: true });
        }
    };

    return (
        <Box>
            <Dealer360View bac={bac} onBack={handleBack} searchMatch={searchMatch} />
        </Box>
    );
};

export default DealerPage;
